import React, { useEffect } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import WeddingDetails from './components/WeddingDetails';
import VideoSection from './components/VideoSection';
import Gallery from './components/Gallery';
import ContactSection from './components/ContactSection';
import VisitorCounter from './components/VisitorCounter';
import './App.css';

function App() {
  useEffect(() => {
    // Add Google Fonts (keeping other fonts as fallbacks)
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500;600;700&family=Dancing+Script:wght@400;600;700&family=Qwigley&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Add Font Awesome for icons (fallback)
    const fontAwesome = document.createElement('link');
    fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css';
    fontAwesome.rel = 'stylesheet';
    document.head.appendChild(fontAwesome);

    // Smooth scrolling polyfill for older browsers
    const smoothScroll = () => {
      if (!('scrollBehavior' in document.documentElement.style)) {
        import('smoothscroll-polyfill').then(smoothscroll => {
          smoothscroll.polyfill();
        });
      }
    };
    smoothScroll();

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(fontAwesome);
    };
  }, []);

  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <StorySection />
      <WeddingDetails />
      <VideoSection />
      <Gallery />
      <ContactSection />
      <VisitorCounter />
      
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-quote">
              <p>"The best thing to hold onto in life is each other."</p>
              <cite>- Audrey Hepburn</cite>
            </div>
            <div className="footer-info">
              <p>© 2025 Aiswarya & Deepak's Wedding</p>
              <p>Made with ❤️ by Aswanth</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
